export default __webpack_public_path__ + "static/media/011-blender.4d63e3f3.svg";